import { ApplicationRef, ComponentRef, Directive, ElementRef, EnvironmentInjector, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, Renderer2, TemplateRef, createComponent } from '@angular/core';
import { PopoverComponent } from './popover.component';
import { LayoutService } from '@app/core/services/layout.service';
import { OutsideClickDirective } from '@app/core/directives/outside-click/outside-click.directive';

@Directive({
    selector: '[ttPopover]',
})
export class PopoverDirective implements OnInit, OnDestroy {
    @Input()
    public ttPopover?: TemplateRef<any>;

    @Input()
    public ttPopoverBackgroundColor: string = 'var(--tt-modal-color);';

    @Output()
    public ttPopoverOpen = new EventEmitter<boolean>();

    private _popoverRef: ComponentRef<PopoverComponent> | null = null;

    private outsideClickDirective: null | OutsideClickDirective = null;

    ttTriggers: string = 'click';

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        console.log('onKeyDown');
        console.log('event :>> ', event);
        if (this.ttTriggers.includes('click') && (event.key === ' ' || event.key === 'Enter')) {
            event.preventDefault();
            event.stopImmediatePropagation();
            event.stopPropagation();

            if (this.open) {
                this.hidePopover();
            } else {
                this.showPopover();
            }
        }
    }

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent) {
        console.log('onClick');
        console.log('event :>> ', event);
        console.log('this.open :>> ', this.open);
        console.dir(this.ttPopover);

        if (this.ttTriggers.includes('click')) {
            event.preventDefault();

            if (this.open) {
                this.hidePopover();
            } else {
                this.showPopover();
            }
        }
    }

    @HostListener('mouseenter')
    onMouseEnter() {
        if (this.ttTriggers.includes('mouseenter')) {
            this.showPopover();
        }
    }

    @HostListener('mouseleave')
    onMouseLeave() {
        if (this.ttTriggers.includes('mouseenter')) {
            this.hidePopover();
        }
    }

    @HostListener('document:scroll')
    onScroll() {
        this.calculatePosition();
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: PointerEvent) {
        console.log('event :>> ', event);
        this.outsideClickDirective?.onDocumentClick(event);
    }

    constructor(private elementRef: ElementRef, private appRef: ApplicationRef, private injector: EnvironmentInjector, private renderer: Renderer2, layout: LayoutService) {
        layout.layoutChanged.subscribe((_) => setTimeout(() => this.calculatePosition(), 400));
    }

    private createPopover() {
        if (!this._popoverRef) {
            this.calculateThisPopover = this.calculatePosition.bind(this);
            this._popoverRef = createComponent(PopoverComponent, { environmentInjector: this.injector });

            this.outsideClickDirective = new OutsideClickDirective(this._popoverRef.location);
            this.outsideClickDirective.ignore = this.elementRef;
            this.outsideClickDirective.onOutsideClick.subscribe(() => this.hidePopover());

            this._popoverRef.setInput('ttPopover', this.ttPopover);
            this._popoverRef.setInput('ttPopoverBackgroundColor', this.ttPopoverBackgroundColor);
        }
    }

    calculatePosition() {
        if (!this.elementRef) return;

        const relativeRect = (this.elementRef.nativeElement as HTMLElement).getBoundingClientRect();
        const popoverWindow: HTMLDivElement | null = document.querySelector('.tt-popover__window');

        if (popoverWindow) {
            const popoverRect = popoverWindow.getBoundingClientRect();
            let left = relativeRect.left + relativeRect.width / 2 - popoverRect.width / 2;
            let top = -1250000;

            if (relativeRect.top - 20 - popoverRect.height < 50) {
                top = relativeRect.top + 9 + relativeRect.height;
                this._popoverRef?.setInput('ttPosition', 'down');
            } else {
                top = relativeRect.top - 9 - popoverRect.height;
                this._popoverRef?.setInput('ttPosition', 'up');
            }
            const centerXOfRelativeElement = relativeRect.right - relativeRect.width / 2;

            if (centerXOfRelativeElement - popoverRect.width / 2 < 0) {
                this.renderer.setStyle(popoverWindow.querySelector('.tt-popover__arrow'), 'left', `${centerXOfRelativeElement}px`);
                this.renderer.removeStyle(popoverWindow.querySelector('.tt-popover__arrow'), 'transform');
                left = 0;
            } else if (centerXOfRelativeElement + popoverRect.width / 2 > window.innerWidth) {
                this.renderer.setStyle(popoverWindow.querySelector('.tt-popover__arrow'), 'transform', `translateX(${(centerXOfRelativeElement / window.innerWidth) * 100 + 50}%)`);
                this.renderer.removeStyle(popoverWindow.querySelector('.tt-popover__arrow'), 'left');
                left = left - Math.abs(centerXOfRelativeElement + popoverRect.width / 2 - window.innerWidth);
            } else {
                this.renderer.removeStyle(popoverWindow.querySelector('.tt-popover__arrow'), 'transform');
                this.renderer.removeStyle(popoverWindow.querySelector('.tt-popover__arrow'), 'left');
            }

            this.renderer.setStyle(popoverWindow, 'top', `0px`);
            this.renderer.setStyle(popoverWindow, 'left', `0px`);
            this.renderer.setStyle(popoverWindow, 'transform', `translate(${left}px, ${top}px)`);
        }
    }
    open = false;
    private showPopover() {
        console.log('showPopover');
        console.log('this._popoverRef :>> ', this._popoverRef);
        if (this._popoverRef && this.open === false) {
            this.open = true;
            const popoverWindow: HTMLDivElement = this._popoverRef?.location.nativeElement.querySelector('.tt-popover__window');

            if (popoverWindow) {
                // initialize somewhere out of view of the user to we can correctly position the popover based on height.
                this.renderer.setStyle(popoverWindow, 'top', -1200000 + 'px');
                this.renderer.setStyle(popoverWindow, 'left', -1200000 + 'px');
            }

            document.body.appendChild(this._popoverRef.location.nativeElement);
            this.appRef.attachView(this._popoverRef.hostView);

            this.ttPopoverOpen.emit(true);

            setTimeout(() => this.calculatePosition());
            // this.calculatePosition();
        }
    }

    private hidePopover() {
        console.log('hidePopover');
        console.log('this._popoverRef :>> ', this._popoverRef);
        if (this._popoverRef && this.open === true) {
            document.body.removeChild(this._popoverRef.location.nativeElement);
            this.appRef.detachView(this._popoverRef.hostView);
            this.open = false;
            this.ttPopoverOpen.emit(false);
        }
    }

    ngOnInit(): void {
        this.createPopover();
    }

    calculateThisPopover: null | (() => void) = null;

    ngOnDestroy(): void {
        this.hidePopover();
        this.outsideClickDirective = null;
    }
}
